import useApi from "./useApi";

export default function useContactMessages(page = 1, perPage = 20){
 const {get} = useApi();
 return get(`admin/ContactMessages?page=${page}&per_page=${perPage}`)
}